'use client'

import { FC } from 'react'
import DatePickerComponent from 'react-datepicker'

import { getMonth, getYear, subYears } from 'date-fns'

import { Input } from '@/components/commons'
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  CalendarMonthOutlineIcon,
} from '@/components/icons'

import 'react-datepicker/dist/react-datepicker.css'
import styles from './styles.module.css'
import { DatePickerProps } from './types'

const DatePicker: FC<DatePickerProps> = ({
  label,
  placeholder,
  inline = false,
  showPopperArrow = false,
  className,
  ...props
}) => {
  const customHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }: any) => (
    <div className={styles['datepicker-header']}>
      <div className="flex">
        <select
          value={getMonth(date)}
          onChange={({ target: { value } }) => changeMonth(Number(value))}
        >
          {[
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro',
          ].map((month, index) => (
            <option key={index} value={index}>
              {month}
            </option>
          ))}
        </select>
        <select
          value={getYear(date)}
          onChange={({ target: { value } }) => changeYear(Number(value))}
        >
          {[...Array(30)].map((_, index) => {
            const year = getYear(subYears(date, 15)) + index
            return (
              <option key={year} value={year}>
                {year}
              </option>
            )
          })}
        </select>
      </div>
      <div className={styles['datepicker-nav']}>
        <button
          className="px-2"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
        >
          <ArrowLeftIcon className="fill-black" />
        </button>
        <button
          className="px-2"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
        >
          <ArrowRightIcon className="fill-black" />
        </button>
      </div>
    </div>
  )

  return (
    <div className={`${styles['datepicker-container']} ${className}`}>
      <div className={styles['datepicker-input']}>
        <DatePickerComponent
          showPopperArrow={showPopperArrow}
          inline={inline}
          renderCustomHeader={customHeader}
          customInput={
            <Input
              wFull
              label={label}
              placeholder={placeholder}
              iconRight={
                <CalendarMonthOutlineIcon className="fill-primary w-[18px] h-[20px]" />
              }
            />
          }
          dateFormat="dd/MM/yyyy"
          wrapperClassName={styles['datepicker-wrapper']}
          {...props}
        />
      </div>
    </div>
  )
}

export default DatePicker
